import type { WhatsappChat } from "@stockline/shared/types/communications/whatsapp-chat"
import { WHATSAPP_CHAT_TABLE } from "../../../lib/offline/resources/communications/whatsapp-chat/db"
import { useAISync } from "../../ai/providers/AISyncProvider"

export interface UseWhatsappChatsFilter {
  instanceId?: string
  archived?: boolean
  enabled?: boolean
  orderBy?: string
}

export function useWhatsappChats(
  filter?: UseWhatsappChatsFilter
): WhatsappChat[] {
  const { reactive } = useAISync()
  return reactive.useQuery<WhatsappChat>(WHATSAPP_CHAT_TABLE, {
    ...filter,
    orderBy: filter?.orderBy ?? "-lastMessageDate",
  })
}

export function useWhatsappChat(id: string | null): WhatsappChat | null {
  const { reactive } = useAISync()
  return reactive.useOne<WhatsappChat>(WHATSAPP_CHAT_TABLE, id ?? "__none__")
}
